import { ContractPropertyName } from '../../../constants';
import { IsTransactionHelperBase } from './IsTransactionHelperBase';
export class IsClaimedTransactionHelper extends IsTransactionHelperBase {
    constructor() {
        super(...arguments);
        this.prefix = ContractPropertyName.claimedTransactions;
    }
}

//# sourceMappingURL=IsClaimedTransactionHelper.js.map
